import { Icon, EpicIcons } from "@constellation-academy/epic-ui";
import { useState } from "react";
import { toast } from "react-toastify";
import { match } from "ts-pattern";
import { cx } from "@styled-system/css";
import { lastUsedLoginMethodClass, wrapperClass } from "./social-login-button.styles";
import type { SocialLoginButtonProps } from "./social-login-button.types";
import { ReactComponent as AppleIcon } from "../../assets/icons/socials/apple.svg";
import { ReactComponent as GoogleIcon } from "../../assets/icons/socials/google.svg";
import { useAuthContext } from "../../hooks/use-auth-context";
import { B1Span } from "../../themes/font-tags";
import { getSupabaseErrorMessage } from "../../util/supabase-error.utils";

export const SocialLoginButton = ({ provider, onClick }: SocialLoginButtonProps) => {
	const { signInWithOAuth, isLastLoginMethod, setLastLoginMethod } = useAuthContext();
	const [isLoading, setIsLoading] = useState(false);

	const iconSize = "16";

	const { label, icon } = match(provider)
		.with("google", () => ({
			label: "Mit Google anmelden",
			icon: <GoogleIcon width={iconSize} height={iconSize} />,
		}))
		.with("apple", () => ({
			label: "Mit Apple anmelden",
			icon: <AppleIcon width={iconSize} height={iconSize} />,
		}))
		.exhaustive();

	const handleClick = async () => {
		try {
			setIsLoading(true);
			await signInWithOAuth(provider);
			setLastLoginMethod(provider);
			onClick?.();
		} catch (error: unknown) {
			const errorMessage = getSupabaseErrorMessage(error);
			toast.error(`${errorMessage.summary}: ${errorMessage.detail}`);
			setIsLoading(false);
		}
	};

	const isLastUsedVariant = isLastLoginMethod(provider);
	const displayLabel = isLoading ? "Wird weitergeleitet..." : label;

	return (
		<button
			type="button"
			onClick={handleClick}
			disabled={isLoading}
			className={cx(wrapperClass, isLastUsedVariant && lastUsedLoginMethodClass)}
		>
			{icon}
			<B1Span>{displayLabel}</B1Span>
			<Icon icon={EpicIcons.ARROW_RIGHT} sizeRem={0.7} />
		</button>
	);
};
